import React, { useState, useEffect, Fragment } from "react";
import { Row, Card, CardBody, Col } from "reactstrap";
import BreadcrumbLink from "../../../components/Common/BreadcrumbLink";
import i18n from "../../../i18n";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Instructions from "./Instructions";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import AlertError from "../../../components/Alerts/AlertError";
import { orgId } from "../../../constants/utils";

const AssignSubAdmin = (props) => {
  document.title = `${i18n.t("AssignSubAdmins")} - ${orgId}`;

  const dispatch = useDispatch()
  const [step, setStep] = useState(1);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [lastName, setLastName] = useState("");
  const [secondLastName, setSecondLastName] = useState("");
  const [company, setCompany] = useState("");
  const [isRole, setIsRole] = useState("SUBADMIN");
  const [infoUser, setInfoUser] = useState({ is_staff: false, permissions: [] })
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);
  const [partnerId, setPartnerId] = useState(null);
  const [costCenterId, setCostCenterId] = useState(null);
  const [costCenterName, setCostCenterName] = useState("");

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);

  useEffect(() => {
    if(data?.data){
      setInfoUser(data.data)
    }
  }, [dispatch, data, loading]);

  useEffect(() => {
    const storedPartnerId = localStorage.getItem('selectedPartnerId');
    const storedCostCenterId = localStorage.getItem('selectedCostCenterId');
    const storedCostCenterName = localStorage.getItem('selectedCostCenterName');
  
    if (storedPartnerId) {
      setPartnerId(parseInt(storedPartnerId));
    }
    if (storedCostCenterId) {
      setCostCenterId(parseInt(storedCostCenterId));
    }
    if (storedCostCenterName) {
      setCostCenterName(storedCostCenterName);
    }
  }, []);

  const switchStep = () => {
    switch (step) {
      case 1:
        return (
          <Step1
            setStep={setStep}
            step={step}
            setName={setName}
            setPhone={setPhone}
            setEmail={setEmail}
            name={name}
            phone={phone}
            email={email}
            token={token}
            lastName={lastName}
            secondLastName={secondLastName}
            company={company}
            partnerId={partnerId}
            isRole={isRole}
            setLastName={setLastName}
            setSecondLastName={setSecondLastName}
            setCompany={setCompany}
            setIsRole={setIsRole}
            infoUser={infoUser}
            setInfoUser={setInfoUser}
          />
        );
      case 2:
        return (
          <Step2
            token={token}
            step={step}
            setStep={setStep}
            name={name}
            phone={phone}
            email={email}
            lastName={lastName}
            secondLastName={secondLastName}
            company={company}
            partnerId={partnerId}
            costCenterId={costCenterId}
            costCenterName={costCenterName}
            isRole={isRole}
            infoUser={infoUser}
            setInfoUser={setInfoUser}
            setErrorAlert={setErrorAlert}
            setErrorAlertMessage={setErrorAlertMessage}
          />
        );
      default:
        break;
    }
  };  

  return (
    <Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <BreadcrumbLink
            title={i18n.t("CostCenter")}
            link='/cost-centers'
            breadcrumbItem={i18n.t("AssignRolesAndPermissions")}
          />
          <Row className="mb-0 pb-0">
            <Card>
              <CardBody>
                <Instructions step={step} />
              </CardBody>
            </Card>
          </Row>
          <Col xxl={12} md={12} xs={12} className="">
            <AlertError
              showAlertError={errorAlert}
              setShowAlertError={setErrorAlert}
              textHeader={i18n.t("Error")}
              textBody={errorAlertMessage}
            />
          </Col>
          <div className="container-fluid">
            <Row>
              <Card>{switchStep()}</Card>
            </Row>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default AssignSubAdmin;
